export const ApplicationTypes = {
  INITIALIZE_APPLICATION: "INITIALIZE_APPLICATION ",
  SET_MENU_VISIBILITY: "SET_MENU_VISIBILITY",
  SET_SEARCH_VISIBILITY: "SET_SEARCH_VISIBILITY",
  SET_GAME_HISTORY_VISIBILITY: "SET_GAME_HISTORY_VISIBILITY",
  SET_LOCALE: "SET_LOCALE",
  SET_COOKIE: "SET_COOKIE",
  SET_MENU: "SET_MENU",
  GET_MENU: "GET_MENU",
  FETCH_THEME: "FETCH_THEME",
  SET_THEME: "SET_THEME",
};
